module.exports = __webpack_public_path__ + "img/mail.16ec6d97.svg";